import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const catalogService = {
  getListUnit: async () => {
    const params = { page: 1, limit: 30 };
    const url = "/store/unit/list-unit";
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getListUnitByPharmacy: async (id) => {
    const params = { id: id };
    const url = "/store/medicine/get-unit-by-id";
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getLitGlassesById: async (id) => {
    const url = `/qlkhambenh/refraction/id`;
    const response = await axiosClient.get(url, { params: { id } });
    return response;
  },
  getListDoiTuongKCB: async () => {
    const url = `/qlkhambenh/dm-doi-tuong/list-dm-doi-tuong`;
    const response = await axiosClient.get(url)
    return response.data;
  },
  getListBaoChe: async () => {
    const url = `store/bao-che/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListDuocChinh: async () => {
    const url = `store/duoc-chinh/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListDuongDung: async (params = { limit: 100, page: 1 }) => {
    const url = `store/usage/list-usage`;
    const response = await axiosClient.get(url, params);
    return response.data;
  },
  getListKhuKham: async () => {
    const url = `/qlkhambenh/dm-khu-kham/list-dm-khu-kham`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListLoaiKCB: async () => {
    const url = `/qlkhambenh/dm-loai-kcb/list-dm-loai-kcb`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListPhong: async () => {
    const url = `/qlkhambenh/dm-phong/list-dm-phong`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTTBH: async () => {
    const url = `/qlkhambenh/dm-trang-thai-bh/list-dm-trang-thai-bh`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiPhieu: async () => {
    const url = `/qlkhambenh/dm-trang-thai-phieu-kham/list-dm-trang-thai-phieu-kham`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiCSKH: async () => {
    const url = `/qlkhambenh/dm-trang-thai-cskh/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiTraThuoc: async () => {
    const url = `/qlkhambenh/dm-trang-thai-tra-thuoc/list-dm-trang-thai-tra-thuoc`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListLichsuTraThuoc: async (id) => {
    const url = `/qlkhambenh/tra-thuoc/lich-su-tra-thuoc`;
    const params = { idPhieuDieuDuong: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getPrintAnalysis: async (id) => {
    const url = `/qlkhambenh/phieu-xet-nghiem-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getPrintDiagnose: async (id) => {
    const url = `/qlkhambenh/phieu-cdha-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getAllListDilate: async () => {
    const url = `/qlkhambenh/dm-thuoc-tra/list-dm-thuoc-tra`;
    const response = await axiosClient.get(url);
    return response.data;
  },
};

export default catalogService;
